const moment = require('moment-timezone')

export const dateToAEST = (incomingDate: any) => {
  const dateString = moment
    .utc(incomingDate)
    .tz('Australia/Sydney')
    .format('DD/MM/YYYY')

  return dateString
}

export default dateToAEST
